<p-card>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="ooCanvasMenuItems"
		dataKey="canvasKey"
		[globalFilterFields]="['ooCanvas.name', 'ooCanvas.displayName']"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} canvases"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search by canvas name or display name</label>
				</span>
				<p-button pRipple styleClass="p-button p-button-raised  m-2" (click)="ooMenuItemCanvasAdd()">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Canvas Name</th>
				<th>Item Display Name</th>
				<th>Description</th>
				<th>Price</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rec>
			<tr>
				<td>{{ rec.ooCanvas?.displayName || rec.ooCanvas?.name }}</td>
				<td>{{ rec.displayName }}</td>
				<td>{{ rec.description }}</td>
				<td>{{ rec.price | currency }}</td>
				<td style="text-align: right">
					<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="ooCanvasMenuItemSelected = rec; newRecord = false">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="ooCanvasMenuItemRemove(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</p-card>

<app-canvas-menu-item-createEdit
	*ngIf="ooCanvasMenuItemSelected"
	[newRecord]="newRecord"
	[ooCanvasMenuItem]="ooCanvasMenuItemSelected"
	[sourceComponent]="'item'"
	[venueKey]="venueKey"
	(ooCanvasMenuItemEmitter)="onNewEditOOCanvasMenuItemReturn($event)"
	(closeEmitter)="ooCanvasMenuItemSelected = undefined; newRecord = false"
></app-canvas-menu-item-createEdit>
